import { Grid, InputLabel, TextField, Paper, Box, Stack, Button, FormControl, FormGroup, FormControlLabel, Checkbox, Chip, OutlinedInput, InputAdornment, IconButton, Tooltip, Typography, Link } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MainCard } from '../../../components/surface/MainCard';
import { SectionBox } from '../../../components/surface/SectionBox';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from 'formik';
import {  apiStore } from '../../../api/ApiFactory';
import { ISeries } from '../../../models/Configuration';
import BentleySeries from "../../../_assets/images/series/bentley-series.jpg";
import EliteSeries from "../../../_assets/images/series/elite-series.jpg";
import FishSeries from "../../../_assets/images/series/fish-series.jpg";
import LeSeries from "../../../_assets/images/series/le-series.jpg";
import DefaultImg from "../../../_assets/images/default-img.png";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SubmitButtonGroup from '../../../components/button/SubmitButtonGroup';
import ImportConfigurator from './ImportConfigurator';
import MainModal from '../../../components/modal/MainModal';

interface IProps {
    record: ISeries | null;
}

const UpdateSeries = () => {

    const [importModal, setMode] = useState(false);
    const openModal = () => setMode(true);
    const closeModal = () => setMode(false);


    const [searchParams, setSearchParams] = useSearchParams();
    const seriesId: string | null = searchParams.get("seriesId");
    const location = useLocation();

    const state: any = location.state ?? null;
    let { record }: IProps = state ?? {};
    const [series, setSeries] = useState<ISeries>();

    const [floorPlans, setFloorPlans] = useState<any>([]);
    const navigate = useNavigate();

    //Calling Series Api
    useEffect(() => {

        if (!seriesId && !record) {
            navigate("/config");
        }
        else {

            const result = apiStore.boatConfigApi.getSeriesList();
            result.then((response) => {
                    const { data } = response;

                    const id = seriesId ? seriesId : record!.id as string;

                    const currentSeries = filterData(data, id);
                    setSeries(currentSeries);
                    setFloorPlans(currentSeries?.floorPlans)
            })
            .catch((error) => {
    
            });

        }
    }, [])

    const filterData = (data: ISeries[], id: string | null) => {
        if (!id) return
        const result = data.filter((item: ISeries) => item.id === parseInt(id))
        return result[0];
    }



    //Formik values
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: series?.id ? series?.id : "",
            name: series?.name ? series?.name : "",
            importConfigName: series?.importConfigName ? series?.importConfigName : "",
            order: series?.order ? series?.order : null,
            msrp: series?.msrp ? series?.msrp : null,
            description: series?.description ? series?.description : "",
            modelCount: series?.modelCount ? series?.modelCount : "",
            floorPlans: [],
            hasTwoTubeModels: series?.hasTwoTubeModels ? series?.hasTwoTubeModels : false,
            hasThreeTubeModels: series?.hasThreeTubeModels ? series?.hasThreeTubeModels : false,
            mediaUrl: series?.mediaUrl ? series?.mediaUrl : ""
        } as ISeries,

        onSubmit: (values: ISeries, { resetForm }) => {
            values.order = values.order ? values.order : null;
            updateSeries(values);
        },
    }
    )

    const updateSeries = (values: ISeries) => {
        const formData = { ...values, floorPlans }
        const response =  apiStore.boatConfigApi.updateSeries(formData);
        
        response
        .then(()=> {
            navigate(-1)
        })
        .finally(() => {
            formik.setSubmitting(false);
        })
    }

    const uploadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        const selectedFile = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const src: string = reader.result as string;
            formik.setFieldValue("mediaUrl", src);
        }
        reader.readAsDataURL(selectedFile);
        const formData = new FormData();
        if (series) {
            formData.append("file", selectedFile);
            formData.append("boatSeriesId", series.id as string);
            const response = apiStore.boatConfigApi.updateSeriesImage(formData)
        }
    }
    const handleFloorPlanInput = () => {
        if (formik.values.floorPlans.length <= 0) {
            return
        }
        const state: any = [...floorPlans]
        state.push(formik.values.floorPlans)
        setFloorPlans(state);
        formik.setFieldValue("floorPlans", []);
    }

    const handelDelete = (index: number) => {
        const state = [...floorPlans];
        state.splice(index, 1);
        setFloorPlans(state);
    }


    return (
        <>
            <MainModal open={importModal} handleClose={closeModal}>
                <ImportConfigurator record={record} closeModal={closeModal}></ImportConfigurator>
            </MainModal>
            <form onSubmit={formik.handleSubmit}>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography className="page-header-label">
                            {"Boat Series"}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={4}>
                    <Grid item xs={12} lg={4}>
                        <MainCard title="GENERAL INFORMATION" divider={true}>
                            <SectionBox>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Stack justifyContent="flex-end" direction="row">
                                            <Typography>
                                                <Link
                                                    sx={{ cursor: "pointer" }}
                                                    underline="none"
                                                    onClick={() => {
                                                        openModal();
                                                    }}
                                                >
                                                {"Import Data"}
                                                </Link>
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="name">Name *</InputLabel>
                                        <TextField
                                            onChange={formik.handleChange}
                                            value={formik.values.name ? formik.values.name : ""}
                                            name="name"
                                            id="name"
                                            size="small"
                                            placeholder="Name *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="importConfigName">Import Config Name *</InputLabel>
                                        <TextField
                                            onChange={formik.handleChange}
                                            value={formik.values.importConfigName ? formik.values.importConfigName : ""}
                                            name="importConfigName"
                                            id="importConfigName"
                                            size="small"
                                            placeholder="Import Config Name *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="order">Order *</InputLabel>
                                        <TextField
                                            onChange={formik.handleChange}
                                            value={formik.values.order ? formik.values.order : ""}
                                            name="order"
                                            id="order"
                                            size="small"
                                            placeholder="Order *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="Description">Description *</InputLabel>
                                        <TextField
                                            onChange={formik.handleChange}
                                            value={formik.values.description ? formik.values.description : ""}
                                            name="description"
                                            id="Description"
                                            size="small"
                                            placeholder="Description *"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="msrp">MSRP *</InputLabel>
                                    
                                        <TextField
                                            onChange={formik.handleChange}
                                            value={formik.values.msrp ? formik.values.msrp : ""}
                                            name="msrp"
                                            id="msrp"
                                            size="small"
                                            placeholder="MSRP"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>

                                        <Box mb={2}>
                                            {
                                                floorPlans && floorPlans.map((floorPlan: string, index: number) => <Chip sx={{ margin: "10px 10px 10px 0" }} label={floorPlan} onDelete={() => handelDelete(index)} key={index} />)
                                            }
                                        </Box>
                                        <InputLabel htmlFor="Description" >Floor Plans *</InputLabel>
                                        <FormControl fullWidth variant="outlined"  >
                                            <OutlinedInput
                                                id="floorPlans"
                                                name="floorPlans"
                                                onChange={formik.handleChange}
                                                value={formik.values.floorPlans}
                                                size="small"
                                                fullWidth
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <Tooltip title="Add Floor Plan">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => handleFloorPlanInput()}
                                                                edge="end"
                                                            >
                                                                <AddCircleIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>

                                        <InputLabel htmlFor="Description">Pontoon Type *</InputLabel>
                                        <FormControl component="fieldset">
                                            <FormGroup aria-label="position">
                                                <FormControlLabel
                                                    labelPlacement="end"
                                                    label={"2 Tube"}
                                                    control={
                                                        <Checkbox
                                                            value="hasTwoTubeModels"
                                                            name="hasTwoTubeModels"
                                                            onChange={formik.handleChange}
                                                            checked={formik.values.hasTwoTubeModels ? true : false}
                                                        />
                                                    }
                                                />
                                            </FormGroup>
                                        </FormControl>
                                        <FormControl component="fieldset">
                                            <FormGroup aria-label="position">
                                                <FormControlLabel
                                                    labelPlacement="end"
                                                    label={"3 Tube"}
                                                    control={
                                                        <Checkbox
                                                            value="hasThreeTubeModels"
                                                            name="hasThreeTubeModels"
                                                            onChange={formik.handleChange}
                                                            checked={formik.values.hasThreeTubeModels ? true : false}
                                                        />
                                                    }
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <SubmitButtonGroup disabled={formik.isSubmitting} />
                            </SectionBox>
                        </MainCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <MainCard title="MEDIA" divider={true}>
                            <SectionBox>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>

                                        <InputLabel htmlFor="btn-upload">
                                            <input id="btn-upload" hidden accept="image/*" type="file" onChange={event => uploadFile(event)} />
                                            <Link sx={{ cursor: "pointer" }} underline="none">
                                                Update Image
                                            </Link>
                                        </InputLabel>

                                    </Grid>
                                    <Grid item xs={12}>
                                        {formik.values.mediaUrl && (
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <img src={formik.values.mediaUrl} style={{ maxHeight: "250px", borderRadius: "5px" }} alt="img" />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </SectionBox>
                        </MainCard>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

export default UpdateSeries